import React, { useEffect, useState } from "react";
import axios from 'axios';

export default function Agendados() {
  const [agendados, setAgendados] = useState([]);
  const mesAtual = String(new Date().getMonth() + 1).padStart(2, "0");
const [filtroMes, setFiltroMes] = useState(mesAtual);
  const [filtroDia, setFiltroDia] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [formEdit, setFormEdit] = useState({});
  const [mostrarConcluidos, setMostrarConcluidos] = useState(false);
  const anoAtual = String(new Date().getFullYear());
const [filtroAno, setFiltroAno] = useState(anoAtual);

  const formatarData = (dataString) => {
  const data = new Date(dataString);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(data);
};
const [idParaExcluir, setIdParaExcluir] = useState(null);
const [mostrarModalExcluir, setMostrarModalExcluir] = useState(false);



  useEffect(() => {
    buscarAgendamentos();
  }, []);

  const buscarAgendamentos = async () => {
    try {
      const response = await axios.get("/api/public/api/agendamentos");
      const agendamentos = response.data;
  
      const agora = new Date();
  
      // Filtrar agendamentos que já passaram e ainda não estão marcados como concluídos
      const vencidos = agendamentos.filter(a => {
        if (a.concluido === 1) return false;
  
        const [horaH, horaM] = a.hora?.split(":") || [0, 0];
        const dataHora = new Date(a.data);
        dataHora.setHours(horaH, horaM, 0, 0);
  
        return dataHora < agora;
      });
  
      // Marcar como concluído no backend
      for (const vencido of vencidos) {
        await axios.put(`/api/public/api/agendamentos/${vencido.id}`, { ...vencido, concluido: 1 });
      }
  
      // Buscar novamente depois de marcar
      const responseFinal = await axios.get("/api/public/api/agendamentos");
      setAgendados(responseFinal.data);
    } catch (error) {
      console.error("Erro ao buscar agendamentos:", error);
    }
  };
  

  const filtrar = (item) => {
    const data = new Date(item.data);
    const ano = String(data.getFullYear());
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");
  
    return (
      (!filtroAno || filtroAno === ano) &&
      (!filtroMes || filtroMes === mes) &&
      (!filtroDia || filtroDia === dia)
    );
  };

  const anos = Array.from({ length: 5 }, (_, i) => {
    const ano = String(new Date().getFullYear() - 2 + i);
    return { value: ano, label: ano };
  });
  

const confirmarExclusao = (id) => {
  setIdParaExcluir(id);
  setMostrarModalExcluir(true);
};

const handleExcluirConfirmado = async () => {
  try {
    await axios.delete(`/api/public/api/agendamentos/${idParaExcluir}`);
    buscarAgendamentos();
  } catch (error) {
    console.error("Erro ao excluir:", error);
  } finally {
    setMostrarModalExcluir(false);
    setIdParaExcluir(null);
  }
};


const iniciarEdicao = (agendamento) => {
  const dataIso = new Date(agendamento.data);
  const dia = String(dataIso.getDate()).padStart(2, "0");
  const mes = String(dataIso.getMonth() + 1).padStart(2, "0");
  const ano = dataIso.getFullYear();
  const dataFormatada = `${dia}/${mes}/${ano}`;

  const valorFormatado = agendamento.valor
    ? `R$ ${Number(agendamento.valor).toFixed(2).replace(".", ",")}`
    : "";

  setEditandoId(agendamento.id);
  setFormEdit({ ...agendamento, data: dataFormatada, valor: valorFormatado });
};


const salvarEdicao = async () => {
  try {
    const [dia, mes, ano] = formEdit.data.split("/");
    const dataFormatada = `${ano}-${mes}-${dia}`;

    let valorFinal = null;
    if (formEdit.valor) {
      const valorLimpo = formEdit.valor.replace(/\D/g, "");
      valorFinal = Number(valorLimpo) / 100;
    }

    await axios.put(`/api/public/api/agendamentos/${editandoId}`, {
      ...formEdit,
      data: dataFormatada,
      valor: valorFinal,
    });

    setEditandoId(null);
    setFormEdit({});
    buscarAgendamentos();
  } catch (error) {
    console.error("Erro ao salvar edição:", error);
  }
};


  const marcarConcluido = async (item, status) => {
    try {
      await axios.put(`api/public/api/agendamentos/${item.id}`, { ...item, concluido: status });
      buscarAgendamentos();
    } catch (error) {
      console.error("Erro ao atualizar status de conclusão:", error);
    }
  };

  const agendamentosPendentes = agendados.filter((a) => a.concluido === 0 && filtrar(a));
  const agendamentosConcluidos = agendados.filter((a) => a.concluido === 1 && filtrar(a));

  const enviarWhatsapp = async (id) => {
  try {
    const resp = await axios.post(`/api/public/api/agendamentos/${id}/enviar-whatsapp`);
    if (resp.data.success) {
      alert("✅ Mensagem enviada com sucesso!");
    } else {
      alert("❌ Falha ao enviar mensagem.");
    }
  } catch (err) {
    alert("❌ Erro na comunicação com o servidor.");
  }
};

const enviarParaTodosHoje = async () => {
  try {
    const resp = await axios.get("/api/public/api/lembretes-hoje");
    alert(`✅ ${resp.data.total_enviados} lembretes enviados com sucesso!`);
  } catch (err) {
    alert("❌ Erro ao enviar lembretes.");
  }
};

const cancelarEdicao = () => {
  setEditandoId(null);
  setFormEdit({});
};




  const meses = [
    { value: "", label: "Todos os meses" },
    { value: "01", label: "Janeiro" },
    { value: "02", label: "Fevereiro" },
    { value: "03", label: "Março" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Maio" },
    { value: "06", label: "Junho" },
    { value: "07", label: "Julho" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Setembro" },
    { value: "10", label: "Outubro" },
    { value: "11", label: "Novembro" },
    { value: "12", label: "Dezembro" },
  ];

  const dias = [
    { value: "", label: "Todos os dias" },
    ...Array.from({ length: 31 }, (_, i) => ({
      value: String(i + 1).padStart(2, "0"),
      label: String(i + 1),
    })),
  ];

  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600 mb-8 text-center ">
          📌 Agendamentos Registrados
        </h2>

        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <select
            value={filtroMes}
            onChange={(e) => setFiltroMes(e.target.value)}
            className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-44 focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            {meses.map((mes) => (
              <option key={mes.value} value={mes.value}>
                {mes.label}
              </option>
            ))}
          </select>
          <select
            value={filtroDia}
            onChange={(e) => setFiltroDia(e.target.value)}
            className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-44 focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            {dias.map((dia) => (
              <option key={dia.value} value={dia.value}>
                {dia.label}
              </option>
            ))}
          </select>
          <select
  value={filtroAno}
  onChange={(e) => setFiltroAno(e.target.value)}
  className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-44 focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
>
  {anos.map((ano) => (
    <option key={ano.value} value={ano.value}>
      {ano.label}
    </option>
  ))}
</select>

          
        </div>
        <button
  onClick={enviarParaTodosHoje}
  className="mt-4 px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
>
  📢 Enviar lembretes de hoje
</button>


        {/* Pendentes */}
        <div className="space-y-6">
          {agendamentosPendentes.map((item) => (
            <div
              key={item.id}
              className="bg-white border border-yellow-200/50 shadow-2xl rounded-xl p-6 transform hover:scale-105 transition-all duration-300 relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
              {editandoId === item.id ? (
                <div className="space-y-4 relative z-10">
                  <input
                    type="text"
                    name="nome"
                    value={formEdit.nome}
                    onChange={(e) => setFormEdit({ ...formEdit, nome: e.target.value })}
                    className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
                  />
                 <input
  type="text"
  name="telefone"
  placeholder="(00)00000-0000"
  value={formEdit.telefone}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, ""); // remove não-dígitos
    if (value.length > 11) value = value.slice(0, 11); // limita a 11 dígitos

    if (value.length >= 2) {
      value = `(${value.slice(0, 2)})${value.slice(2)}`;
    }
    if (value.length >= 9) {
      value = value.slice(0, 9) + "-" + value.slice(9);
    }

    setFormEdit({ ...formEdit, telefone: value });
  }}
  className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
/>

<input
  type="text"
  name="data"
  placeholder="DD/MM/AAAA"
  value={formEdit.data}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, ''); // remove tudo que não for número

    if (value.length > 8) value = value.slice(0, 8); // limita a 8 dígitos

    // aplica a máscara: 2 primeiros, depois mais 2, depois o resto
    if (value.length >= 5) {
      value = value.replace(/^(\d{2})(\d{2})(\d{1,4})$/, "$1/$2/$3");
    } else if (value.length >= 3) {
      value = value.replace(/^(\d{2})(\d{1,2})$/, "$1/$2");
    }

    setFormEdit({ ...formEdit, data: value });
  }}
  className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
/>

                  <input
                    type="time"
                    name="hora"
                    value={formEdit.hora}
                    onChange={(e) => setFormEdit({ ...formEdit, hora: e.target.value })}
                    className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
                  />

                  <textarea
  name="observacoes"
  placeholder="Observações"
  value={formEdit.observacoes || ""}
  onChange={(e) => setFormEdit({ ...formEdit, observacoes: e.target.value })}
  rows={3}
  className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
/>

<input
  type="text"
  name="valor"
  placeholder="Valor (R$)"
  value={formEdit.valor || ""}
  onChange={(e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const numero = Number(raw) / 100;
    const formatado = isNaN(numero)
      ? ""
      : `R$ ${numero.toFixed(2).replace(".", ",")}`;
    setFormEdit({ ...formEdit, valor: formatado });
  }}
  className="border-0 bg-gray-100 text-gray-900 p-3 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
/>

                  <div className="flex gap-3 mt-4">
                    <button
                      onClick={salvarEdicao}
                      className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Salvar
                    </button>
                    <button
                      onClick={cancelarEdicao}
                      className="bg-gradient-to-r from-gray-500 to-gray-600 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Cancelar
                    </button>
                    
                  </div>
                </div>
              ) : (
                <div className="relative z-10">
                  <p className="text-gray-900 text-lg">
  <strong className="text-yellow-400">📅 Data:</strong> {formatarData(item.data)} às {item.hora}
</p>
                  <p className="text-gray-900 text-lg"><strong className="text-yellow-400">👤 Nome:</strong> {item.nome}</p>
                  <p className="text-gray-900 text-lg"><strong className="text-yellow-400">📞 Telefone:</strong> {item.telefone}</p>
                  <p className="text-gray-900 text-lg"><strong className="text-yellow-400">📍 Endereço:</strong> {item.rua}, Nº {item.numero}, {item.bairro}, {item.cidade}</p>
                  
                  {item.complemento && <p className="text-gray-900 text-lg"><strong className="text-yellow-400">🏠 Complemento:</strong> {item.complemento}</p>}
                  {item.observacoes && (
  <p className="text-gray-900 text-lg">
    <strong className="text-yellow-400">📝 Observações:</strong> {item.observacoes}
  </p>
)}

{item.valor && (
  <p className="text-gray-900 text-lg">
    <strong className="text-yellow-400">💰 Valor:</strong> R$ {Number(item.valor).toFixed(2).replace(".", ",")}
  </p>
)}
                  <div className="flex gap-3 mt-4">
                    
                    <button
                      onClick={() => iniciarEdicao(item)}
                      className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => confirmarExclusao(item.id)}
                      className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Excluir
                    </button>
                    <button
                      onClick={() => marcarConcluido(item, 1)}
                      className="bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Concluído
                    </button>
                    <button
 onClick={() => enviarWhatsapp(item.id)}
  className="text-green-600 hover:text-green-800 font-semibold text-sm"
>
  📤 Enviar WhatsApp
</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Concluídos */}
        {agendamentosConcluidos.length > 0 && (
          <div className="text-center mt-12">
            <button
              onClick={() => setMostrarConcluidos(!mostrarConcluidos)}
              className="relative bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-3 rounded-xl shadow-2xl hover:shadow-green-500/50 transform hover:-translate-y-1 transition-all duration-300"
            >
              {mostrarConcluidos ? "⬅️ Ocultar Concluídos" : "📁 Ver Concluídos"}
              <span className="absolute -top-3 -right-3 bg-red-600 text-white text-xs font-bold rounded-full w-7 h-7 flex items-center justify-center shadow-md">
                {agendamentosConcluidos.length}
              </span>
            </button>
          </div>
        )}

        {mostrarConcluidos && agendamentosConcluidos.length > 0 && (
          <>
            <h3 className="text-2xl font-semibold mt-8 text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600 text-center">
              ✅ Agendamentos Concluídos
            </h3>
            <div className="space-y-6 mt-6">
              {agendamentosConcluidos.map((item) => (
                <div
                  key={item.id}
                  className="bg-green-100 border border-green-400/50 shadow-2xl rounded-xl p-6 transform hover:scale-105 transition-all duration-300 relative overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="relative z-10">
                    <p className="text-gray-900 text-lg">
  <strong className="text-black-400">📅 Data:</strong> {formatarData(item.data)} às {item.hora}
</p>
                    <p className="text-gray-900 text-lg"><strong className="text-green-400">👤</strong> {item.nome}</p>
                    <p className="text-gray-900 text-lg"><strong className="text-green-400">📞</strong> {item.telefone}</p>
                    <p className="text-gray-900 text-lg"><strong className="text-green-400">📍</strong> {item.rua}, Nº {item.numero}, {item.bairro}, {item.cidade}</p>
                    {item.complemento && <p className="text-gray-900 text-lg"><strong className="text-green-400">🏠</strong> {item.complemento}</p>}
                    <button
                      onClick={() => marcarConcluido(item, 0)}
                      className="mt-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                    >
                      Desmarcar Concluído
                    </button>
                  </div>
                  
                </div>
                
              ))}
            </div>
          </>
        )}
      </div>
      {mostrarModalExcluir && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md text-center animate-fade-in">
      <h3 className="text-xl font-bold text-gray-800 mb-4">❗ Confirmar Exclusão</h3>
      <p className="text-gray-700 mb-6">Deseja realmente excluir este agendamento?</p>
      <div className="flex justify-center gap-6">
        <button
          onClick={handleExcluirConfirmado}
          className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-2 rounded-lg shadow"
        >
          Sim, excluir
        </button>
        <button
          onClick={() => setMostrarModalExcluir(false)}
          className="bg-gray-400 hover:bg-gray-500 text-white font-semibold px-6 py-2 rounded-lg shadow"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}